






















































































import { Component, mixins, namespace, Prop } from 'nuxt-property-decorator'
import { mdiMinus, mdiPlus } from '@mdi/js'
import MixinProduct from '~/assets/mixins/product'
import { filterUrl } from '~/assets/filters/url'
import { CART_PATH } from '~/assets/config/path'
import ComponentFormButton from '~/components/form/button.vue'

const siteStore = namespace('site')

@Component({
  components: {
    ComponentFormButton,
  },
  name: 'ProductBuyButton',
})
export default class ComponentProductBuyButton extends mixins(MixinProduct) {
  @Prop({ type: String }) readonly size!: string
  @Prop({ type: Boolean, default: false })
  readonly canIncreaseQuantity!: boolean

  @siteStore.Getter('getOptionsCanChangeQuantity')
  readonly getOptionsCanChangeQuantity!: boolean

  private mdiMinus = mdiMinus
  private mdiPlus = mdiPlus

  private get classLarge() {
    return {
      [this.$style.large]: this.size === 'large',
    }
  }

  private async buy() {
    if (this.isInCart && this.aspectsForBuy.length === 0) {
      await this.$router.push(filterUrl(CART_PATH))
    } else {
      await this.toCart(1)
    }
  }
}
